import {Injectable} from '@angular/core';
import { HttpClient } from "@angular/common/http";

import {map, Observable} from "rxjs";

import {WebResponse} from "@commons/models/remote.response/WebResponse";

import {BaseHttpService} from "@shared/services-http/base-http.service";

import {sendSurveyRequestModel} from "@survey/models/send-survey-request.model";
@Injectable({
  providedIn: 'root'
})
export class SurveyHttpService extends BaseHttpService {

  constructor(
    private httpClient: HttpClient
  ) {
    super();
  }

  sendSurvey(surveyDetails: sendSurveyRequestModel): Observable<WebResponse> {
    return this.httpClient.post(this.getUrl('/SendSurveyResult'), surveyDetails)
      .pipe(map(x => x as WebResponse));
  }

  // GB bez wywołania tej metody dla użytkowników którzy nigdy nie wypełniali wcześniej ankiety zapis jej wyniku nie był możliwy
  // ponieważ brakowało jak sądzę wiersza z ankietą dla usera który ją wypełnił
  // Tą metodę można wywoływać wielokrotnie ponieważ kiedyś to jej wynik określał czy ankieta ma być pokazana czy też nie.
  createSurveyInDb(): Observable<WebResponse> {
    return this.httpClient.get<WebResponse>(this.getUrl('/ShowSurvey'));
  }

}
